import BaseCarousel from './base';
import { ZOOMED_ATTRIBUTE } from './constants';

export default class CarouselWithArrows extends BaseCarousel {
  constructor({
    galleryContainer,
    containerSelector,
    elementSelector,
    previousSelector,
    nextSelector,
    thumbnailSelector,
    iteratorClass
  }) {
    super({
      containerSelector,
      elementSelector,
      thumbnailSelector,
      iteratorClass
    });

    this.galleryContainer = galleryContainer;
    this.nextSelector = nextSelector;
    this.previousSelector = previousSelector;
  }

  handleTouchEnd = (e) => {
    if (!this.galleryContainer?.getAttribute(ZOOMED_ATTRIBUTE)) {
      super.handleTouchEnd(e);
    }
  };

  handleTouchStart = (e) => {
    if (!this.galleryContainer?.getAttribute(ZOOMED_ATTRIBUTE)) {
      super.handleTouchStart(e);
    }
  };

  initializeEventListeners = () => {
    super.initializeEventListeners();

    if (this.container) {
      [...this.container.getElementsByClassName(this.previousSelector)].forEach((element) => {
        element.addEventListener('click', this.selectPrevious);
      });

      [...this.container.getElementsByClassName(this.nextSelector)].forEach((element) => {
        element.addEventListener('click', this.selectNext);
      });

      this.container.addEventListener('touchstart', this.handleTouchStart);
      this.container.addEventListener('touchend', this.handleTouchEnd);
    }
  };
}
